import React, {useCallback, useEffect, useMemo, useState} from 'react';

import {useAuth, useLang, useTheme} from "../../hooks";
import {MyBackdrop, MyButton, MyImage, MySelect, MyText} from "../../components";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ROUTE_PATH} from "../../constants";
import {THEME as THEMES_CONST, LANG_KEY} from '../../constants'
import {useDispatch, useSelector} from "react-redux";

import {CloseOutlined, UserOutlined} from "@ant-design/icons";
import {MenuItem, StyledHeader} from "./Header.styles";
import {HeaderProps} from "./Header.props";
import {MenuIcon, NotificationIcon, QuitIcon} from "../../assets";
import {Avatar, Badge, Button, Col, Divider, Modal, Popover, Row, Spin, Typography} from "antd";
import {LogoIcon} from "../../assets/icons/header/LogoIcon";
import {ProfileIcon} from "../../assets/icons/header/ProfileIcon";
import {selectStore} from "../../store/selector";
import {RootState} from "../../store";
import dayjs from "dayjs";
import {fetchSetNotificationAction} from "../../store/pages/profile/actions";
import {setThemeColor} from "../../utils/setThemeColor";
import {DefaultTokenTheme} from "../../assets/themes/defaultTheme";
import {IMenuItems} from "../../types";
import uploadIcon from "../../assets/icons/page/entrant/admission/icon_upload.svg";

export const Header = (props: HeaderProps): React.ReactElement => {
  const navigate = useNavigate();
  const {themeConfig} = useTheme()
  const dispatch = useDispatch()
  const {theme} = useTheme()

  const {handleLogout, menu} = useAuth()
  const {handleToggleTheme} = useTheme()
  const {handleChangeLang, lang} = useLang()

  const initialPopoverShowState = {
    menu: false,
    profile: false,
    notification: false
  }

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [popoverShow, setPopoverShow] = useState(initialPopoverShowState)

  const {profile: {userProfile: profileDataState, notification: notificationState}}: RootState = useSelector(selectStore)

  const location = useLocation()
  const childrenLocation = `/${location.pathname.split('/')[1]}` || '/'

  useEffect(() => {
    setPopoverShow(initialPopoverShowState)
  }, [location])

  const handleLogoutButton = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleModalOkButton = useCallback(() => {
    handleLogout()
  }, [])

  const handleModalCancelButton = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleToggleThemeButton = useCallback(() => {
    handleToggleTheme()
  }, [])

  const handleNavigate = useCallback((route: any) => {
    navigate(route)
  }, [])

  const handleChangeLangSelect = useCallback((value: any) => {
    handleChangeLang(value)
  }, [])

  const handleClickMenu = useCallback((item: any) => {
    if(item.open === 'self'){
      navigate(item.url)
    } else {
      window.location.replace(`${process.env.REACT_APP_FULLSTACK_URL}${item.url}`)
    }
  }, [])

  const profileRender = useMemo(() => {
    return (
      <Row style={{width: 160}}>
        <Col span={24}>
          <Typography.Text strong style={{fontSize: 14}}>
            {`${profileDataState.data?.lastname} ${profileDataState.data?.firstname} ${profileDataState.data?.middlename}`}
          </Typography.Text>
        </Col>

        {/*<Col span={24}>*/}
        {/*  <Typography.Text type='secondary' style={{fontSize: 12}}>*/}
        {/*    Админ*/}
        {/*  </Typography.Text>*/}
        {/*</Col>*/}

        <Col span={24}>
          <Divider style={{margin: '12px 0'}}/>
        </Col>

        <Col span={24}>
          <MyButton type='text' title='Профиль' onClick={() => handleNavigate(ROUTE_PATH.PROFILE)}
                    style={{width: '100%', display: 'flex', alignItems: 'center', gap: 6, padding: 0}}
                    icon={<UserOutlined style={{fontSize: 20}}/>}/>

        </Col>

        {/*<Col span={24}>*/}
        {/*  <MyButton type='text' title='Кураторство' onClick={() => handleNavigate(ROUTE_PATH.CURATING)}*/}
        {/*            style={{width: '100%', display: 'flex', alignItems: 'center', gap: 6, padding: 0}}*/}
        {/*            icon={<UserOutlined style={{fontSize: 20}}/>}/>*/}

        {/*</Col>*/}

        <Col span={24}>
          <MyButton type='text' title='Выйти' onClick={handleLogoutButton}
                    style={{width: '100%', display: 'flex', alignItems: 'center', gap: 6, padding: 0}}
                    icon={<QuitIcon style={{fontSize: 20}}/>}/>
        </Col>
      </Row>
    )

  }, [profileDataState.data])

  // const menuRender = useMemo(() => {
  //   return (
  //     <div style={{display: "grid", gap: 20, gridTemplateColumns: '1fr 1fr 1fr 1fr'}}>
  //       {
  //         menu.map(item => (
  //           <MenuItem key={item.id} to={item.path} className={childrenLocation === item.path ? 'active' : ''}>
  //             <Row gutter={24} align='middle'>
  //               <Col span={18}>
  //                 <MyText size={18} color='var(--c-title-text)' weight={500} className='text'>
  //                   {item.label}
  //                 </MyText>
  //               </Col>
  //             </Row>
  //           </MenuItem>
  //         ))
  //       }
  //     </div>
  //   )
  // }, [childrenLocation, menu])

  const notificationRender = useMemo(() => {
    return (
      <Row style={{maxWidth: 300}} gutter={[16, 8]}>
        <Col span={24}>
          <Row>
            {
              notificationState.data.length > 0 ? notificationState.data.slice(0, 5).map((item: any) => (
                <Col span={24} key={item.id}>
                  <Row>
                    <Col span={24}>
                      <MyText color='var(--c-icon)' size={12}>
                        {dayjs(item.created_at).format('DD.MM.YYYY HH:mm')}
                      </MyText>
                    </Col>
                    <Col span={24}>
                      <MyText size={12}>
                        {item.caption_current}
                      </MyText>
                    </Col>
                  </Row>
                </Col>
              ))
                :
                <Col span={24}>
                  <MyText size={16} color='rgba(140, 140, 140, 1)' style={{display: "block"}} align='center'>
                    Уведомлений нету
                  </MyText>
                </Col>
            }
          </Row>
        </Col>

        {
          notificationState.data.length > 0 &&
          <>
            <Col span={24}>
              <hr style={{height: 1, backgroundColor: 'var(--c-line)'}}/>
            </Col>

            <Col span={24}>
              <MyButton width='100%' type='text' title='Отметить как прочитанное' onClick={() => dispatch(fetchSetNotificationAction)}/>
            </Col>
          </>
        }

      </Row>
    )
  }, [notificationState.data])

  return (
    <>
      <MyBackdrop isShow={popoverShow.menu || popoverShow.profile || popoverShow.notification}
                  setIsShow={() => setPopoverShow(initialPopoverShowState)}/>
      <StyledHeader {...props}>
        <Row justify='center'>
          <Col span={20}>

            <Row justify='space-between' align='middle' style={{height: 48}}>
              <Col>
                <Link to={ROUTE_PATH.MAIN}>
                  <Row align='middle' gutter={16}>
                    <Col>
                      <LogoIcon/>
                    </Col>
                    <Col>
                      <span className="logo-text">Электронды колледж</span>
                    </Col>
                  </Row>
                </Link>
              </Col>
              <Col>
                <Row align='middle' gutter={16}>
                  {menu.map((item: IMenuItems) => (
                      <Col key={item.label}>
                        <Popover placement="bottom" trigger="click" /*d-content={menuRender}*/
                                 onOpenChange={(open) => setPopoverShow(prevState => ({
                                   ...prevState,
                                   menu: open
                                 }))} content={(
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                              {
                                item.child?.map((menuItem: any) => (
                                    <MyButton type='text' key={menuItem.label} style={{textAlign: 'left'}}
                                              onClick={() => handleClickMenu(menuItem)}>
                                      {menuItem.label}
                                    </MyButton>
                                ))
                              }
                            </div>
                        )}>
                          <MyButton type='text' size='large'>
                            <MyText
                                color={setThemeColor(theme, DefaultTokenTheme.subtitle, DefaultTokenTheme.disabled)}>
                              {item.label}
                            </MyText>
                          </MyButton>
                        </Popover>
                      </Col>
                  ))}

                  <Spin spinning={profileDataState.loading}>
                    <Col>
                      <Popover placement="bottomLeft" trigger="click" content={profileRender}
                               onOpenChange={(open) => setPopoverShow(prevState => ({
                                 ...prevState,
                                 profile: open
                               }))} open={popoverShow.profile}>
                        <Button type='text' size='large' className='profile'>
                          <Avatar size={24} icon={<ProfileIcon/>}/>
                          <span> {`${profileDataState.data?.lastname} ${profileDataState.data?.firstname} ${profileDataState.data?.middlename}`}</span>
                        </Button>
                      </Popover>
                    </Col>
                  </Spin>

                  <Col style={{display: 'flex', alignItems: 'center'}}>
                    <Popover placement="bottomLeft" trigger="click" content={notificationRender}
                             onOpenChange={(open) => setPopoverShow(prevState => ({
                               ...prevState,
                               notification: open
                             }))} open={popoverShow.notification}>
                      <Badge count={notificationState.data.length} offset={[0, 10]} color='var(--c-notification)'>
                        <Button style={{height: 'auto'}} type='text'
                                icon={<NotificationIcon width={'100%'} height={'100%'}/>}/>
                      </Badge>
                    </Popover>
                  </Col>

                  <Col>
                    <MySelect
                      defaultValue="RU"
                      style={{
                        width: 60,
                      }}
                      bordered={false}
                      onChange={(value) => handleChangeLangSelect(value)}
                      value={lang}
                      options={[
                        {
                          value: LANG_KEY.RU,
                          label: 'RU',
                        },
                        {
                          value: LANG_KEY.KZ,
                          label: 'KZ',
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

          </Col>
        </Row>
      </StyledHeader>

      <Modal
        title="Выход из личного кабинета"
        width={708}
        centered
        open={isModalOpen}
        onOk={handleModalOkButton}
        onCancel={handleModalCancelButton}
        okText='Выйти'
        cancelText='Отмена'
        className='modal-restore'
        closeIcon={<CloseOutlined style={{color: '#fff'}}/>}
        okButtonProps={{
          danger: true,
          ghost: true
        }}
      >
        <Row>
          <Col span={24}>
            <MyText
              color={themeConfig?.token?.colorText}
              align='center'
              size={16}
            >
              Вы уверены, что хотите выйти из личного кабинета?
            </MyText>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

